export enum RegistrationGaType {
  Standard = 'STANDARD',
}
